// Which version of Cobrain's judgement a person is on, and going back to one (module 04 D234; REQ-2026-09-25-06).
//
// MIRROR OF the answer of GET /api/brain/versions in apps/api/src/routes/brain-version.ts, field for field. A copy
// and not an import because the two packages do not depend on one another.
import { viewFetch as fetch } from '../view-as.js';
import { ApiError, Unauthenticated } from '../api.js';

export interface VersionRow {
  label: string;
  releasedOn: string;
  headline: string;
  changes: string[];
  canRun: boolean;
  cannotRun: string | null;
  isNewest: boolean;
  isMine: boolean;
}

export interface Versions {
  versions: VersionRow[];
  mine: string | null;
  newest: string | null;
  /** The ones a person may go back to: the last three this build can run (D234). */
  offered: string[];
  chosen: { label: string; chosenAt: string; reason: string | null } | null;
  lastPass: { version: string | null; asked: string | null; ranAt: string } | null;
}

async function json<T>(res: Response): Promise<T> {
  if (res.status === 401) throw new Unauthenticated();
  const body = (await res.json().catch(() => ({}))) as { error?: unknown };
  if (!res.ok) throw new ApiError(res.status, typeof body.error === 'string' ? body.error : `${res.status} ${res.statusText}`);
  return body as T;
}

export const brainVersions = {
  list: (store: string) => fetch(`/api/brain/versions?store=${encodeURIComponent(store)}`, { credentials: 'same-origin' }).then((r) => json<Versions>(r)),
  choose: (store: string, label: string) =>
    fetch('/api/brain/version', {
      method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ store, label }),
    }).then((r) => json<{ mine: string; rebuilding: boolean }>(r)),
};

/**
 * What the menu lists: the versions a person may go back to, newest first, and their own choice even when it has
 * fallen out of the last three, so the menu never hides what they are on.
 */
export function menuRows(v: Versions): VersionRow[] {
  return v.versions.filter((r) => v.offered.includes(r.label) || r.label === v.mine);
}
